import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

export const IconButton = ({ icon, onClick }) => (
  <StyledButton className="iconButton" type="button" onClick={onClick}>
    <img src={icon} alt="Icon" />
  </StyledButton>
);

IconButton.defaultProps = {
  onClick: () => {
    //empty object
  },
};

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

const StyledButton = styled.button`
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
